<template>
  <div>
    <MultipleAreaBase
      v-model="inputedValue"
      :width="width"
      :title="title"
      :tables="pageData"
      :isFooter="isFooter"
    >
      <template v-slot:[pageData[0].name]>
        <ClientInfo
          :recItems="recItems"
          :pageType="isHistoryType ? 'history' : 'register'"
        />
      </template>
      <template v-slot:[pageData[1].name]>
        <OperationDetail
          :recItems="recItems"
          :type="pageType.en"
          :isEdit="isEdit"
          :isTotalAmount="!authority.isOutsideStaff ? isTotalAmount : false"
        >
          <template #button v-if="isHistoryType">
            <slot :name="pageData[1].buttonAreaName" />
          </template>
        </OperationDetail>
      </template>

      <template v-if="!isEdit" v-slot:[pageData[2].name]>
        <v-row class="mx-3 my-2">
          <v-col>
            <Remarks
              :title="$t('order.order_company-note-phrase')"
              :text="$t('sale.sale_not-listed-on-the-invoice')"
              v-model="remarks.private"
              :isRegister="isHistoryType"
              @updateRemarks="updateRemarksPrivate"
            />
          </v-col>
          <v-col>
            <Remarks
              :title="$t('sale.sale_invoice-remarks-column')"
              :text="$t('sale.sale_public-info-on-the-invoice')"
              v-model="remarks.client"
              :isRegister="isHistoryType"
              @updateRemarks="updateRemarksClient"
            />
          </v-col>
        </v-row>
      </template>

      <!-- 詳細のみ -->
      <template v-if="isHistoryType" v-slot:[pageData[3].name]="{ item }">
        <!-- 出庫履歴 -->
        <slot :name="pageData[3].name" v-bind:item="item" />
      </template>
      <template v-if="isHistoryType" v-slot:[pageData[4].name]="{ item }">
        <!-- 入金履歴 -->
        <slot :name="pageData[4].name" v-bind:item="item" />
      </template>
      <template v-if="isHistoryType" v-slot:[pageData[5].name]="{ item }">
        <!-- 返金履歴 -->
        <slot :name="pageData[5].name" v-bind:item="item" />
      </template>
      <template v-if="isHistoryType" v-slot:[pageData[6].name]="{ item }">
        <!-- 修正履歴 -->
        <slot :name="pageData[6].name" v-bind:item="item" />
      </template>

      <template #footer>
        <slot name="footer" />
      </template>
    </MultipleAreaBase>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import MultipleAreaBase from '../MultipleAreaBase'

import headersHistory from '@/views/sales/History/headers'
import ClientInfo from '@/components/layouts/ClientConfirmation/CustomerInfo/CustomerInfoBase'
import OperationDetail from '@/components/layouts/OperationDetail/OperationDetail'
import { ProductTable, Remarks } from '@/components/items'

// import NormalButton from '@/components/items/Buttons/NormalButton'

export default {
  components: {
    MultipleAreaBase,
    ClientInfo,
    OperationDetail,
    // ProductTable,
    Remarks
    // NormalButton
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    recItems: {
      type: Object,
      require: false,
      default: () => ({})
    },

    pageData: {
      type: Array,
      require: true,
      default: () => [{}, {}, {}, {}, {}, {}, {}]
    },

    isHistoryType: { default: false },
    isFooter: { default: false },
    isEdit: { default: false },
    isTotalAmount: { default: true }
  },
  data: () => ({
    pageType: {
      en: 'sale',
      ja: '注文'
    },

    recDetail: {
      productListHeaders: headersHistory.productListHeaders
    },

    remarks: {
      private: '',
      client: ''
    }
  }),
  methods: {
    updateRemarksPrivate(...args) {
      const [remarks] = args
      this.$emit('updateRemarks', remarks, 'private')
    },
    updateRemarksClient(...args) {
      const [remarks] = args
      this.$emit('updateRemarks', remarks, 'client')
    },
    setDefaultRemarks() {
      if (!this.recItems.saleNote || this.recItems.saleNote.length == 0) {
        this.remarks = {
          private: '',
          client: ''
        }
        return
      }
      const privateRemarks = this.recItems.saleNote.find((ele) => ele.type == 1)
      if (privateRemarks) this.remarks.private = privateRemarks.body
      const clientRemarks = this.recItems.saleNote.find((ele) => ele.type == 2)
      if (clientRemarks) this.remarks.client = clientRemarks.body
    }
    // register() {
    //   this.$emit('register')
    // },
    // cancel(id) {
    //   this.$emit('cancel', id)
    // },
    // edit(rec) {
    //   this.$emit('edit')
    // }
  },
  computed: {
    ...mapGetters('User', ['authority']),
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    remarks: {
      deep: true,
      handler(newVal, oldVal) {
        this.$emit('editRemarks', newVal)
      }
    },
    recItems: {
      deep: true,
      handler(newVal, oldVal) {
        this.setDefaultRemarks()
      }
    },
    'inputedValue.dialog': async function (val) {
      // val ? await this.ini() : null
    }
  }
}
</script>
<style lang="scss" scoped>
// .productTableCom {
//   ::v-deep .v-data-table th {
//     background-color: rgba(151, 198, 234, 0.1);
//     padding-left: 30px;
//   }
//   ::v-deep .v-data-table td {
//     padding-left: 30px;
//   }
// }
.normalNumberInput {
  width: 180px;
}
.stepComponent {
  width: 150px;
}
.btnStyle {
  width: 90px;
}
</style>
